import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"Avenir", "Helvetica", "Arial", sans-serif', // your default font
    },
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontFamily: '"Avenir", "Helvetica", "Arial", sans-serif',
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    fontFamily: '"Avenir", "Helvetica", "Arial", sans-serif',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    fontFamily: '"Avenir", "Helvetica", "Arial", sans-serif',
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    fontFamily: '"Avenir", "Helvetica", "Arial", sans-serif',
                },
                option: {
                    fontFamily: '"Avenir", "Helvetica", "Arial", sans-serif',
                },
            },
        },
    },
});

interface PDThemeProviderProps {
    children: React.ReactNode;
}

const PDThemeProvider: React.FC<PDThemeProviderProps> = ({ children }) => {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default PDThemeProvider;
